export default __webpack_public_path__ + "static/media/reserve.c9e7f977.svg";